/*eslint-disable*/
import Api from './';

class BattleApi {
    static show(id, params) {
        return Api.axios.get('/battle/' + id, { params }).then(response => response.data.battle);
    }

    static create(battle) {
        return Api.axios.post('/battle', battle).then(response => response.data.battle);
    }

    static update(id, battle) {
        return Api.axios.put('/battle/' + id, battle).then(response => response.data.battle);
    }

    static delete(id) {
        return Api.axios.delete('/battle/' + id).then(response => response.data);
    }

    static list(params, cancelToken = null) {
        return Api.axios
            .get('/battle', { params, cancelToken })
            .then(response => (params.all ? response.data.battles : response.data));
    }

    static pay(params) {
        return Api.axios.post('/battle/pay', { params }).then(response => response.data);
    }

    static getDefaultImageUrl() {
        return api.env.API_ENDPOINT + '/storage/user-files/avatars/battles/no-photo.svg';
    }

    static inviteOpponent(params) {
        return Api.axios.post('opponent', params).then(response => response.data);
    }

    static opponentsForTraining(params) {
        return Api.axios.post('opponents-for-training', params).then(response => response.data);
    }

    static getListOpponentsForBattle(params) {
        return Api.axios.get('list-opponents-for-battle', { params }).then(response => response.data);
    }

    static cancelInvite(params) {
        return Api.axios.post('cancel-invitation', params).then(response => response.data);
    }

    static acceptInvite(params) {
        return Api.axios.post('accept-invitation', params).then(response => response.data);
    }

    static updateGameData(params) {
        return Api.axios.post('update-game-data', params).then(response => response.data);
    }

    static completeBattle(params) {
        return Api.axios.post('complete-battle', params).then(response => response.data);
    }

    static pauseBattle(params) {
        return Api.axios.post('pause-battle', params).then(response => response.data);
    }

    static resumeBattle() {
        return Api.axios.post('resume-battle').then(response => response.data);
    }

    static getReconnectStatus() {
        return Api.axios.get('get-reconnect-status').then(response => response.data);
    }

    static updateActivity() {
        return Api.axios.put('update-activity').then(response => response.data);
    }

    static getBattleResultStats() {
        return Api.axios.get('battle-result-stats').then(response => response.data);
    }

    static getRecordHolderBattles(params) {
        return Api.axios.post('get-record-holder-battles', params).then(response => response.data);
    }
}

export default BattleApi;
